import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AsistenciaState } from './asistencia.actions';

// 🔥 SELECTOR PRINCIPAL DEL FEATURE
export const selectAsistenciaState = createFeatureSelector<AsistenciaState>('asistencia');

// 🔥 SELECTORES DE ESTADOS DE ACTIVIDADES
export const selectBreakActivo = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.breakActivo
);

export const selectBanoActivo = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.banoActivo
);

export const selectYaRegistroEntrada = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.yaRegistroEntrada
);

export const selectYaMarcoSalida = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.yaMarcoSalida
);

// 🔥 SELECTORES DE LOADING STATES
export const selectLoadingBreak = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.loadingBreak
);

export const selectLoadingBano = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.loadingBano
);

export const selectLoadingAsistencia = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.loadingAsistencia
);

export const selectLoadingSalida = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.loadingSalida
);

// 🔥 SELECTORES DE CONTADORES
export const selectTotalBreaks = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.totalBreaks
);

export const selectTotalBanos = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.totalBanos
);

// 🔥 SELECTORES DE PERMISOS
export const selectPuedeTomarBreak = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.puedeTomarBreak
);

export const selectPuedeIrAlBano = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.puedeIrAlBano
);

// 🔥 SELECTORES DE TIEMPO
export const selectTiempoBreakActual = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.tiempoBreakActual
);

export const selectTiempoBanoActual = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.tiempoBanoActual
);

// 🔥 SELECTOR DE ERROR
export const selectAsistenciaError = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.error
);

// 🔥 NUEVO: SELECTOR PARA ASISTENCIAS OPTIMIZADAS
export const selectAsistenciasAsesorOptimizadas = createSelector(
  selectAsistenciaState,
  (state: AsistenciaState) => state.asistenciasAsesorOptimizadas
);

// Añade este código al final del archivo

export const selectHeaderState = createSelector(
  selectBreakActivo,
  selectBanoActivo,
  selectTotalBreaks,
  selectTotalBanos,
  selectPuedeTomarBreak,
  selectPuedeIrAlBano,
  selectYaRegistroEntrada,
  selectYaMarcoSalida,
  selectLoadingBreak,
  selectLoadingBano,
  selectLoadingSalida,
  selectLoadingAsistencia,
  (
    breakActivo, banoActivo, totalBreaks, totalBanos, puedeTomarBreak,
    puedeIrAlBano, yaRegistroEntrada, yaMarcoSalida, loadingBreak,
    loadingBano, loadingSalida, loadingAsistencia
  ) => ({
    breakActivo,
    banoActivo,
    totalBreaks,
    totalBanos,
    puedeTomarBreak,
    puedeIrAlBano,
    yaRegistroEntrada,
    yaMarcoSalida,
    loadingBreak,
    loadingBano,
    loadingSalida,
    loadingAsistencia
  })
);